import React from 'react';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, } from '@mui/material';
/**
 * 削除等の破壊的操作を実行する前に確認を行う共通ダイアログ
 * @description window.confirm の代替として、デザイン正本に準拠した MUI Dialog を提供する
 */
const ConfirmDialog = ({ open, title, message, confirmLabel = '削除', cancelLabel = 'キャンセル', onConfirm, onCancel, loading = false, confirmDisabled = false, children, 'data-testid': dataTestId, maxWidth = 'xs', }) => (React.createElement(Dialog, { open: open, onClose: onCancel, fullWidth: true, maxWidth: maxWidth, "data-testid": dataTestId },
    React.createElement(DialogTitle, null, title),
    React.createElement(DialogContent, null,
        message ? React.createElement(DialogContentText, null, message) : null,
        children),
    React.createElement(DialogActions, null,
        React.createElement(Button, { onClick: onCancel, disabled: loading }, cancelLabel),
        React.createElement(Button, { onClick: onConfirm, color: "error", variant: "contained", disabled: loading || confirmDisabled, startIcon: loading ? React.createElement(CircularProgress, { size: 20 }) : null }, confirmLabel))));
export default ConfirmDialog;
